import React, { Component } from "react";
import Strings from "@my-dld/assets/strings";
import Popup from "@my-dld/components/Popup/Popup";

interface Props {
	payRef: string;
	onDismiss: () => void;
	onDownloadReceipt: () => void;
}

interface State {
}

class RVPaymentSuccess extends Component<Props, State> {
	constructor( props: Props ) {
		super( props );
	}

	render() {
		const { payRef } = this.props;
		return <Popup
			id={ "RVPaySuccessPopup" }
			modalMainContainer={ "modal fade" }
			clickOutsideToDismiss={ false }
			showCloseButton={ true }
			closeClass={ "close modal-close-svg-icon" }
			closeSpanClass={ "close-svg-icon" }
			modalBodyContainer={ "modal-body" }
			showIcon={ false }
			title={ Strings.rental_evaluation }
			onDismiss={ this.dismissModel }>
			<div className="d-flex flex-column">
				<div className="check-icon">
					<i className="fa fa-check"/>
				</div>
				<p className="text-center">{ Strings.rv_payment_success }</p>
				<p className="text-center">{ Strings.rv_note_ref }</p>
				<div className="refn-box">
					{ Strings.reference_number }: <span>{ payRef }</span>
				</div>
			</div>
			<div className="modal-footer d-flex justify-content-center">
				<button type="button" className="btn btn_1" onClick={ this.props.onDownloadReceipt }>{ Strings.download_receipt }</button>
			</div>
		</Popup>;
	}

	private dismissModel = () => {
		if ( this.props.onDismiss )
			this.props.onDismiss();
	};
}

export default RVPaymentSuccess;

